import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-33531cd2")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-3" }, " Pool creation requires 2 transactions: ", -1)
const _hoisted_2 = { class: "flex justify-between sm:flex-row flex-col space-x-0 sm:space-x-4 sm:space-y-0 space-y-4" }
const _hoisted_3 = { class: "card-container" }
const _hoisted_4 = { class: "card-step text-white" }
const _hoisted_5 = {
  key: 1,
  class: "text-gray-200 dark:text-gray-400"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3 flex-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Create Pool")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Create Pool ")
const _hoisted_8 = {
  key: 1,
  class: "ml-4 text-sm"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "card-container" }
const _hoisted_11 = { class: "card-step text-white" }
const _hoisted_12 = {
  key: 1,
  class: "text-gray-200 dark:text-gray-400"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3 flex-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Join Pool")
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Join Pool ")
const _hoisted_15 = {
  key: 1,
  class: "ml-4 text-sm"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_PoolCreateConfirmModal = _resolveComponent("PoolCreateConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BalCard, { class: "mt-4 mb-3" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.poolAddress !== '')
                ? (_openBlock(), _createBlock(_component_BalIcon, {
                    key: 0,
                    name: "check",
                    class: "text-white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, "1"))
            ]),
            _hoisted_6,
            (_ctx.poolAddress === '')
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createModalVisible = true)),
                  disabled: !_ctx.canCreatePool,
                  size: "sm",
                  loading: _ctx.creating,
                  "loading-label": "Creating..."
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createTextVNode("Pool address: " + _toDisplayString(_ctx.poolAddress), 1),
                  _hoisted_9,
                  _createTextVNode("Pool id: " + _toDisplayString(_ctx.poolId), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.joined)
                ? (_openBlock(), _createBlock(_component_BalIcon, {
                    key: 0,
                    name: "check",
                    class: "text-white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "2"))
            ]),
            _hoisted_13,
            (!_ctx.joined)
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  onClick: _ctx.joinPool,
                  disabled: _ctx.poolAddress === '',
                  size: "sm",
                  loading: _ctx.joining,
                  "loading-label": "Joining..."
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled", "loading"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, " Joined "))
          ])
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.createModalVisible)
        ? (_openBlock(), _createBlock(_component_PoolCreateConfirmModal, {
            key: 0,
            onCreate: _ctx.createPool,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createModalVisible = false))
          }, null, 8, ["onCreate"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}